import keyMirror from 'react/lib/keyMirror';

export default keyMirror({
  PUBLIC: null,
  UNLISTED: null
});


/** WEBPACK FOOTER **
 ** ./constants/ZineStatus.js
 **/